// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"7":"753f3d7a","97":"9b859ae7","207":"8f601fb9","488":"4ede2a20","508":"87f4e84b","520":"f185b91a","583":"627ce295","632":"3aa7267f","676":"80ef8c31","741":"541f4d86","947":"6025146b"}[chunkId] + ".chunk.js";
};